<!-- eslint-disable vue/no-unused-refs -->
<template>

  <div class="car-manage">
    <el-tabs v-model="changeType" type="card" @tab-click="payeeTypeChangeHandle">
      <el-tab-pane v-for="(item, index) in accruedTypeList" :label="item.label" :name="item.value + ''" :key="index">
      </el-tab-pane>
    </el-tabs>
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="1" ref="BLM-search">
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchData.createTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            clearable
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="变更计划ID">
          <el-input v-number:integer v-model="searchData.id" placeholder="请输入" clearable>
          </el-input>
        </el-form-item>

        <el-form-item :label="changeType === '1' ? '应收ID' : '应付ID'">
          <el-input v-number:integer v-model="searchData.accruedId" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect v-model="searchData.deptIdList" multiple :isAll="false" />
        </el-form-item>

        <template slot="moreBtn">
          <el-form-item>
            <el-button :loading="BLMloading" type="primary" @click="searchHandle">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getReset">重置</el-button>
          </el-form-item>
          <el-form-item>
            <export
              v-if="judgePermission('accrued_change_export')"
              :exportTemplate="exportTemplate"
              :filename="exportFileName"
              :params="getSearchParamrs()"
            >
            </export>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div style="margin-top: 20px"></div>
    <!-- 开始 ---列表 -->
      <QS-common-table ref="table"
        :loading="BLMloading"
        :data="tableData"
        :columns="headData"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <template slot="col-accruedId-header">
          <span v-if="changeType === '1'">应收ID</span>
          <span v-else>应付ID</span>
        </template>
        <template slot="col-beforeDate-header">
          <span v-if="changeType === '1'">变更前应收日期</span>
          <span v-else>变更前应付日期</span>
        </template>
        <template slot="col-afterDate-header">
          <span v-if="changeType === '1'">变更后应收日期</span>
          <span v-else>变更后应付日期</span>
        </template>
      </QS-common-table>
    <!-- 结束 ---列表 -->
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { getAccruedChangeList } from '@/api/financeApi/accruedChange'
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'AccruedChange',
  data() {
    return {
      exportTemplate: 'accruedChange',
      changeType: '1', // 1、应收；2、应付
      routeType: '1',
      routeAccruedId: '',
      searchData: {
        createTime: [],
        id: '',
        accruedId: '',
        changeType: '',
        deptIdList: [],
      },
      // 表头
      headData: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '变更计划ID',
          },
        },
        {
          name: 'accruedId',
          columnProps: {
            prop: 'accruedId',
            label: '应收ID',
          },
        },
        {
          name: 'beforeAmount',
          columnProps: {
            prop: 'beforeAmount',
            label: '变更前金额(元)',
          },
          getText: ({ row }) => this.numberWithCommas(row.beforeAmount),
        },
        {
          name: 'afterAmount',
          columnProps: {
            prop: 'afterAmount',
            label: '变更后金额(元)',
          },
          getText: ({ row }) => this.numberWithCommas(row.afterAmount),
        },
        {
          name: 'beforeDate',
          columnProps: {
            prop: 'beforeDate',
            label: '变更前应收日期',
          },
        },
        {
          name: 'afterDate',
          columnProps: {
            prop: 'afterDate',
            label: '变更后应收日期',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '变更创建时间',
          },
          render: ({ row }) => {
            return <div>
              <span>{row.gmtCreate.split(' ')[0]}</span>
              <br/>
              <span>{row.gmtCreate.split(' ')[1]}</span>
            </div>
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            label: '创建人',
          },
        },
        {
          name: 'remarks',
          columnProps: {
            prop: 'remarks',
            label: '变更说明',
          },
          render: ({ row }) => {
            const couponCode = row.reasonBizId ? String(row.reasonBizId) : ''
            if (row.reasonType === 10 && couponCode) {
              return (
                <span>
                  使用优惠券抵扣，券码：
                  <span
                    class="a-hover-link"
                    onClick={() => this.goCouponVerifyDetail(couponCode)}
                  >
                    {couponCode}
                  </span>
                </span>
              )
            }
            if (row.reasonType === 11 && couponCode) {
              return (
                <span>
                  优惠券取消退回，券码：
                  <span
                    class="a-hover-link"
                    onClick={() => this.goCouponVerifyDetail(couponCode)}
                  >
                    {couponCode}
                  </span>
                </span>
              )
            }
            return row.remarks || '--'
          },
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
      ],
      tableData: [],
      BLMloading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
    }
  },
  mounted() {
    const { accruedId = '', type = '' } = this.$route.query || {}
    this.routeAccruedId = accruedId !== '' ? String(accruedId) : ''
    if (accruedId !== '') {
      this.searchData.accruedId = accruedId
    }
    if (String(type) === '2') {
      this.changeType = '2'
      this.routeType = '2'
    } else {
      this.changeType = '1'
      this.routeType = '1'
    }
    this.getRender()
    this.$refs['BLM-search'].searchMoreClick()
  },
  computed: {
    accruedTypeList() {
      return this.dictParseList(selectOption.accruedTypeDict)
    },
    exportFileName() {
      return Number(this.changeType) === 1 ? '应收变更记录.xlsx' : '应付变更记录.xlsx'
    },
    pagination() {
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        total: this.total,
      }
    },
  },
  methods: {
    // tab切换
    payeeTypeChangeHandle() {
      if (this.routeAccruedId) {
        this.searchData.accruedId = this.changeType === this.routeType ? this.routeAccruedId : ''
      }
      this.searchHandle()
    },
    // 查询
    searchHandle() {
      this.pageNum = 1
      this.pageSize = 10
      this.getRender()
    },
    // 重置按钮
    getReset() {
      this.routeAccruedId = ''
      this.searchData = {
        createTime: [],
        id: '',
        accruedId: '',
        changeType: '',
        deptIdList: [],
      }
      this.searchHandle()
    },
    async getRender() {
      this.BLMloading = true
      try {
        const { code, data } = await getAccruedChangeList(this.collectParams('all'))
        if (code === 1) {
          this.tableData = data.items
          this.total = data.totalNum
        }
        this.BLMloading = false
      } catch (error) {
        this.BLMloading = false
      }
    },
    collectParams(clotp) {
      let gmtCreateStart = null
      let gmtCreateEnd = null
      if (this.searchData.createTime instanceof Array) {
        gmtCreateStart = this.searchData.createTime.length > 0 ? this.searchData.createTime[0] : null
        gmtCreateEnd = this.searchData.createTime.length > 0 ? this.searchData.createTime[1] : null
      }
      const a = {
        id: Number(this.searchData.id) || null,
        accruedId: this.searchData.accruedId || null,
        type: Number(this.changeType) || null,
        gmtCreateStart,
        gmtCreateEnd,
        deptIdList: this.searchData.deptIdList || [],
      }
      if (clotp === 'all') {
        a.pageNum = this.pageNum
        a.pageSize = this.pageSize
      }

      return a
    },
    getSearchParamrs() {
      return this.collectParams()
    },
    handleTableChange({ pagination }) {
      this.pageSize = pagination.pageSize
      this.pageNum = pagination.pageNum
      this.getRender()
    },
    goCouponVerifyDetail(couponId) {
      this.$router.push({
        path: '/activity/coupon/verifyRecord',
        query: {
          couponId,
        },
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
